import React, { useContext, useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom"; // Import the useLocation hook

import { AppContext } from "../../components/States/AppContext";
import { Outlet } from "react-router-dom";

//components
import PrimaryWave from "../MainButtons/PrimaryWave";
import SecondaryWave from "../MainButtons/SecondaryWave";
import HrButton from "../MainButtons/HrButton";
import Spo2Button from "../MainButtons/Spo2Button";
import RR from "../MainButtons/RR";
import Pulse from "../MainButtons/Pulse";
import PVC from "../MainButtons/PVC";
import StButton from "../MainButtons/StButton";

// styles
import { LockBox, LockBoxLight } from "../../GlobalStyles.styles";
import { SmartKeysGrid } from "../Settings/SmartKeyBox.elements";

// images & videos
import lead1 from "../../img/waveforms/LI.mp4";
import alarmWave from "../../img/waveforms/alarms/alarml2.mp4";
import RespPageWave from "../../img/waveforms/resp.mp4";
import plethWave from "../../img/waveforms/pleth.mp4";

import plethflat from "../../img/waveforms/pleth-flat4.mp4";
import { NumericBox1 } from "../MainButtons/NumericBoxes";
import VideoPlayer from "../Common/VideoPlayer";

const SettingLayout = () => {
  const { state, setState } = useContext(AppContext);
  const location = useLocation();

  const selectedNumericValue = state.numericValues.find(
    (numericValue) => numericValue.isSelected
  );

  let trueBoxName = null;
  if (selectedNumericValue) {
    const box = selectedNumericValue.box;
    for (const boxName in box) {
      if (box[boxName] === true) {
        trueBoxName = boxName;
        break;
      }
    }
  }

  return (
    <>
      {state.isLocked && <LockBox />}
      <LockBoxLight />

      <SmartKeysGrid>
        <div
          style={{ display: "grid", placeItems: "center", background: "black" }}
        >
          {/* waves */}

          {location.pathname === "/settings/resp"}

          <div style={{ position: "relative" }}>
            {location.pathname === "/settings/resp" || location.pathname === "/settings/respadjustsize" ? (
              <VideoPlayer
                src={RespPageWave}
                loop={true}
              />
            ) : (location.pathname === "/settings/spo2" ||
                location.pathname === "/settings/spo2mode" ||
                location.pathname === "/settings/spo2alarmlimits" ||
                location.pathname === "/settings/spo2tonemodulation" ||
                location.pathname === "/settings/pulse") &&
              state.spoContinuous ? (
              <VideoPlayer
                src={plethWave}
                loop={true}
              />
            ) : (location.pathname === "/settings/spo2" ||
                location.pathname === "/settings/spo2mode" ||
                location.pathname === "/settings/spo2alarmlimits" ||
                location.pathname === "/settings/spo2tonemodulation" ||
                location.pathname === "/settings/pulse") &&
              !state.spoContinuous ? (
              <VideoPlayer
                src={plethflat}
                loop={true}
              />
            ) : location.pathname === "/settings/changenumeric" ? (
              <>
                {trueBoxName === "spo" || trueBoxName === "pulse" ? (
                  <VideoPlayer
                    src={state.spoContinuous ? plethWave : plethflat}
                    loop={true}
                  />
                ) : trueBoxName === "rr" ? (
                  <VideoPlayer
                    src={RespPageWave}
                    loop={true}
                  />
                ) : !state.ecg ? (
                  <VideoPlayer
                    src={lead1}
                    loop={true}
                    ecgOff={true}
                  />
                ) : (
                  <VideoPlayer
                    src={lead1}
                    loop={true}
                  />
                )}
              </>
            ) : state.ecg === false && state.spoContinuous ? (
              <div style={{ display: "grid", placeItems: "center" }}>
                {/* <video
                  src={pulseWave}
                  autoPlay
                  playsInline
                  loop
                  muted
                  loading="eager"
                  style={{ width: "90%", margin: "auto" }}
                ></video> */}
                <SecondaryWave />
              </div>
            ) : state.annotateOrRelearn ? (
              <>
                <div
                  style={{
                    position: "absolute",
                    top: "0",
                    width: "100%",
                    height: "100%",
                    background: "white",
                    // filter(opacity)
                    opacity: ".2",
                    zIndex: "1000",
                  }}
                ></div>

                <PrimaryWave />
              </>
            ) : !state.ecg ? (
              <VideoPlayer
                src={lead1}
                loop={true}
                ecgOff={true}
              />
            ) : state.initiateAlarms ? (
              <VideoPlayer
                src={alarmWave}
                loop={true}
              />
            ) : (
              <VideoPlayer
                src={lead1}
                loop={true}
              />
            )}
          </div>
        </div>

        {/* numeric */}

        <div>
          {location.pathname === "/settings/resp"  || location.pathname === "/settings/respadjustsize" ? (
            <RR />
          ) : location.pathname === "/settings/pulse" ? (
            <Pulse />
          ) : location.pathname === "/settings/arrhythmia" ? (
            <>
              {trueBoxName === "pvc" ? (
                <PVC />
              ) : trueBoxName === "st" ? (
                <StButton />
              ) : (
                <HrButton />
              )}
            </>
          ) : location.pathname === "/settings/stleads" ||
            location.pathname === "/settings/stviews" ? (
            <StButton />
          ) : location.pathname === "/settings/spo2" ||
            location.pathname === "/settings/spo2mode" ||
            location.pathname === "/settings/spo2alarmlimits" ||
            location.pathname === "/settings/spo2tonemodulation" ? (
            <Spo2Button setting />
          ) : location.pathname === "/settings/changenumeric" ? (
            <>
              {/* {trueBoxName === "hr" && !state.ecg ? (
                <Spo2Button setting />
              ) : (
                <NumericBox1 number={selectedNumericValue.boxName} setting />
              )} */}
              <NumericBox1 number={selectedNumericValue.boxName} setting />
            </>
          ) : (
            <>
              {state.ecg ? <HrButton /> : <Spo2Button setting />}
              {/* <HrButton /> */}
            </>
          )}
        </div>

        <Outlet />
      </SmartKeysGrid>
    </>
  );
};

export default SettingLayout;
